// The generator's eight gemstone sizes and Gemstone: Cut may carry unenchantable.
// This identity-only exception never bypasses class/subclass or Sanguine exclusion.
const sanctionedGemstonePartIds = new Set([
    '583B7BBA-A802-4830-931B-5417A8B25C0C',
    'A288CEEA-0824-46AE-A5E9-2C45696B5569',
    'C8777AD8-E02C-2769-FBF4-D3619BD0115F',
    '3965A960-7C23-1C16-0C02-3CC45D6BCDBA',
    '94A30796-D243-60B2-5EA4-FC4E46684C90',
    'D772138F-9019-AE08-4F3C-5DAAD6A35964',
    'A0E0814C-F954-9BD0-0053-8B5827491CEF',
    'FAC3A084-D93E-6918-9858-AEDEF3B11C89',
    '44BDAC87-F09D-F2FD-F550-0829EEB4DA82',
]);

/** Shared list/authoring rule; callers supply their native lean/wrapped readers. */
export function enchantmentPartEligible<Part>(part: Part, read: {
    itemField(part: Part, key: string): unknown;
    has(part: Part, key: string): boolean;
}): boolean {
    return read.itemField(part, 'item_type') !== 'sanguine'
        && !read.has(part, 'requires_class') && !read.has(part, 'requires_subclass')
        && (!read.has(part, 'unenchantable')
            || sanctionedGemstonePartIds.has(String(read.itemField(part, 'item_id') ?? '').toUpperCase()));
}
